import { useLoaderData } from '@remix-run/react';
import { useEffect } from 'react';
import type { loader } from '~/routes/_index';

export function useUserWayWidget() {
  const { DISABLE_THIRD_PARTY_SCRIPTS, userwayAccountId } =
    useLoaderData<typeof loader>();

  useEffect(() => {
    if (
      DISABLE_THIRD_PARTY_SCRIPTS ||
      !userwayAccountId ||
      typeof window === 'undefined'
    )
      return;

    if (document.querySelector('script[data-userway]')) return;

    const script = document.createElement('script');
    script.src = 'https://cdn.userway.org/widget.js';
    script.setAttribute('data-account', userwayAccountId);
    script.setAttribute('data-userway', 'true');
    script.defer = true;
    document.body.appendChild(script);
  }, [userwayAccountId]);
}
